<template>
    <div
        :class="{
            thread: true,
            active: medCase.id === currentReport,
        }"
        :data-id="medCase.id"
    >
        <div class="thread__status">
            <span
                :class="medCase.state"
            ></span>
        </div>
        <div class="thread__details">
            <b>{{ medCase.medicalCase.shortId }}</b>
            <div class="thread__author">
                <b>{{  medCase.patient.gender === 'male' ? "Mężczyzna" : "Kobieta"}}</b> lat: <b>{{ medCase.patient.age }}</b>
            </div>
            <div class="thread__date">
                Zgłoszono <b>{{ medCase.startedAt }}</b>
            </div>
            <div class="thread__author">
                przez <b>{{ medCase.author.you ? "Ciebie" : medCase.author.name }}</b>
            </div>
            <div v-if="medCase.read.unreadContent.you" class="thread__badges">
                <span class="thread__badge" v-if="['message', 'message_and_attachment'].includes(medCase.read.unreadContent.you)">
                    Nowa wiadomość
                </span>
                <span class="thread__badge" v-if="['attachment', 'message_and_attachment'].includes(medCase.read.unreadContent.you)">
                    Nowy plik
                </span>
            </div>
        </div>
        <IconFlag class="thread__urgent" v-if="medCase.urgent" />
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { IconFlag } from "@/components/ui/icons";

export default {
    name: "ThreadListItem",
    components: {
        IconFlag,
    },
    computed: mapGetters({
        userData: "getUserData",
    }),
    props: {
        medCase: {
            type: Object,
            required: true,
        },
        currentReport: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss">
.thread {
    $this: &;
    padding: 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e7e7e7;
    background: transparent;
    &.active {
        background: #ffffff;
    }

    &__badges {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 8px;
    }

    &__badge {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 2px 8px 2px 4px;
        border: 2px solid #e1e1e1;
        color: gray;
        border-radius: 20px;
        font-size: 12px;
        &:before {
            content: " ";
            display: inline-block;
            width: 15px;
            height: 15px;
            right: 0;
            background: #36baca;
            border-radius: 15px;
            transition: all 200ms;
            flex-shrink: 0;
        }
    }

    &__status {
        flex: 1;
        & > span {
            display: block;
            width: 40px;
            height: 40px;
            margin-right: 15px;
            border-radius: 50%;
            transition: all 200ms;
            &.new {
                background: #94c120 no-repeat 50%;
                background-image: url("data:image/svg+xml,%3Csvg aria-hidden='true' focusable='false' data-prefix='far' data-icon='comment' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' class='svg-inline--fa fa-comment fa-w-16 fa-5x'%3E%3Cpath fill='%23fff' d='M256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z' class=''%3E%3C/path%3E%3C/svg%3E");
                background-size: 50%;
            }
            &.acknowledged {
                background: #36baca no-repeat 50%;
                background-image: url("data:image/svg+xml,%3Csvg aria-hidden='true' focusable='false' data-prefix='far' data-icon='comment' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' class='svg-inline--fa fa-comment fa-w-16 fa-5x'%3E%3Cpath fill='%23fff' d='M256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z' class=''%3E%3C/path%3E%3C/svg%3E");
                background-size: 50%;
            }
            &.ongoing {
                background: rgba(0, 0, 0, 0.5) no-repeat 50%;
                background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M144 208c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z'/%3E%3C/svg%3E");
                background-size: 50%;
            }
            &.resolved {
                background: rgba(0, 0, 0, 0.2) no-repeat center;
                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' %3E%3Cpath fill='%23ffffff' d='M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z'%3E%3C/path%3E%3C/svg%3E");
                background-size: 50%;
            }
        }
    }
    &__date,
    &__author {
        font-size: 12px;
        color: #8f8f8f;
    }
    &__details {
        flex: 1 1 85%;
    }

    &__urgent {
        padding: 8px;
        border-radius: 50px;
        background: #fde8e8;
        color: #e55353;
    }
}
</style>
